// Single source of truth for where an account lands after auth / "open app".
export function homeFor(user) {
  if (!user) return "/login";
  if (user.account_type === "einvoice") return "/einvoicing/app";
  if (user.account_type === "contractor") return "/marketplace";
  return "/dashboard";
}

export const isEinvoiceAcct = (user) => user?.account_type === "einvoice";
